import { makeStyles } from "@fluentui/react-components";

export const useStyles = makeStyles({
  toastLink: {
    "@media (forced-colors: active), (-ms-high-contrast:active)": {
      border: "1px solid WindowText",
      borderRadius: "2px",
      padding: "1.5px",
    },
  },
});
